(() => {
  if (window.fashionStorePolishReady) return;
  window.fashionStorePolishReady = true;
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
    if (!input.closest('variant-selects')) return;
    const group = input.closest('.product-form__input');
    const value = group?.querySelector('[data-fashion-option-value]');
    if (value) value.textContent = input.value;
  });
  const mobile = window.matchMedia('(max-width: 749px)');
  let nextId = 0;
  function init() {
    document.querySelectorAll('footer .footer-block').forEach((block) => {
      if (block.dataset.fashionAccordion) return;
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content:not(.footer-block-image)');
      if (!heading || !content) return;
      block.dataset.fashionAccordion = 'true';
      content.dataset.fashionFooterContent = 'true';
      content.id ||= `fashion-footer-menu-${++nextId}`;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fashion-footer-toggle';
      button.textContent = heading.textContent;
      button.setAttribute('aria-controls', content.id);
      const title = document.createElement('span');
      title.className = 'fashion-footer-title';
      title.textContent = heading.textContent;
      heading.replaceChildren(title, button);
      button.addEventListener('click', () => {
        if (!mobile.matches) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        block.dataset.fashionOpen = String(open);
        content.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
    refresh();
  }
  function refresh() {
    document.querySelectorAll('[data-fashion-accordion]').forEach((block) => {
      const button = block.querySelector('.fashion-footer-toggle');
      const content = block.querySelector('[data-fashion-footer-content]');
      const open = !mobile.matches || block.dataset.fashionOpen === 'true';
      button.disabled = !mobile.matches;
      button.setAttribute('aria-expanded', String(open));
      content.hidden = !open;
    });
  }
  mobile.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', init);
  init();
})();
